import React, { useState, useEffect, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { getIndexes } from "common/utils";
import styled from "styled-components";
import Table from "common/graphs/Table/Table";
import { TextWithIcon } from "common/graphs/Table/TableRenders";

const TableContainer = styled.div`
  td div {
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      font-size: 20px;
      margin-left: 10px;
    }
  }
`;

const NEW_HEADER = `BQN     DATE  TIME  TIMEZONE`;

const parseTimeSettings = (input) => {
  const [header, ...rows] = input.trim().split("\n");
  const headerAttrs = header.trim().split(/\s+/);
  const headerIndex = getIndexes(header);
  return rows.map((row) => {
    const rowAttrs = row.trim().split(/\s+/);
    const bqn = rowAttrs[headerIndex["BQN"]];
    const dateTime = rowAttrs[headerIndex["TIME"]];
    const [date, timeFull] = dateTime.split("T");
    const [time] = timeFull.split("+");
    const timezone = rowAttrs[headerIndex["TIMEZONE"]];
    return {
      BQN: bqn,
      DATE: date,
      TIME: time,
      TIMEZONE: timezone,
    };
  });
};

const getFilteredResponse = ({ response, mode, bqnId }) => {
  if (mode === "standalone" || bqnId === "all") {
    return response;
  }
  return response.filter((row) => parseFloat(row["BQN"]) === parseFloat(bqnId));
};

const getColumns = (mode, actions) => {
  return [
    ...(mode !== "standalone"
      ? [
          {
            label: "BQN",
            id: "BQN",
            numeric: true,
          },
        ]
      : []),
    {
      label: "DATE",
      id: "DATE",
      numeric: false,
      renderCell: (value) => {
        if (!value) {
          return null;
        }
        const valueWithIcon = (
          <div>
            {value} <i className="material-icons">edit</i>
          </div>
        );
        return <TextWithIcon value={valueWithIcon} />;
      },
      onClick: (value, row) => {
        const bqn = row["BQN"];
        const time = row["TIME"];
        actions.send("set-date", { date: value, time, bqn });
      },
    },
    {
      label: "TIME",
      id: "TIME",
      numeric: false,
      renderCell: (value) => {
        if (!value) {
          return null;
        }
        const valueWithIcon = (
          <div>
            {value} <i className="material-icons">edit</i>
          </div>
        );
        return <TextWithIcon value={valueWithIcon} />;
      },
      onClick: (value, row) => {
        const bqn = row["BQN"];
        const date = row["DATE"];
        actions.send("set-time", { date, time: value, bqn });
      },
    },
    {
      label: "TIMEZONE",
      id: "TIMEZONE",
      numeric: false,
      renderCell: (value) => {
        if (!value) {
          return null;
        }
        const valueWithIcon = (
          <div>
            {value} <i className="material-icons">edit</i>
          </div>
        );
        return <TextWithIcon value={valueWithIcon} />;
      },
      onClick: (value, row) => {
        const bqn = row["BQN"];
        actions.send("set-timezone", { timezone: value, bqn });
      },
    },
  ];
};

const DataTimeList = () => {
  const [tableData, setTableData] = useState(null);
  const actions = useContext(ActionsContext);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  useEffect(() => {
    let timeoutId;
    let isMounted = true;

    const doLoad = () => {
      if (!isMounted) return;
      ifCl
        .run("show system date detail")
        .then(parseTimeSettings)
        .then((response) => {
          setTableData(response);
        })
        .then(() => {
          if (isMounted) {
            timeoutId = setTimeout(doLoad, 1000);
          }
        });
    };
    doLoad();
    const unsubscribe = actions.recv("do-load", doLoad);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
      unsubscribe();
    };
  }, []);

  if (tableData === null) {
    return null;
  }
  const filteredResponse = getFilteredResponse({
    response: tableData,
    mode,
    bqnId,
  });
  return (
    <TableContainer>
      <Table
        isSelectable={false}
        isRowSelectable={false}
        data={filteredResponse}
        sort={true}
        columns={getColumns(mode, actions)}
        search={true}
        exportCSV={false}
        rowsPerPageNr={50}
      />
    </TableContainer>
  );
};

export default DataTimeList;
